export const getCodes = () => async (dispatch, getState, api) => {
    try {
        return await api.get(`/ccd/calculations/procedurecode-changer`);
    } catch (err) {
        return err;
    }
};

export const getExcludedCodes = () => async (dispatch, getState, api) => {
    try {
        return await api.get(`/procCodes/excluded`);
    } catch (err) {
        return err;
    }
};
